import { render, staticRenderFns } from "./block-entities-filter.vue?vue&type=template&id=30c70952&scoped=true&lang=pug&"
import script from "./block-entities-filter.vue?vue&type=script&lang=js&"
export * from "./block-entities-filter.vue?vue&type=script&lang=js&"
import style0 from "./block-entities-filter.vue?vue&type=style&index=0&id=30c70952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c70952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
